import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

export interface SurveyTemplateSearchedArgs {
  resultReturned: boolean;
  textTyped?: string;
}

/**
 * A survey template was searched
 */
export const surveyTemplateSearched = (args: SurveyTemplateSearchedArgs): void => {
  Segment.track('Searched Survey Template', keysToSnakeCase(args));
};
